import React from 'react';
import type { V2Route } from '../units/types';

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  // 旧「動画広告」（/ads/video）は新しい動画画面（/test-ui/video）にまとめた
  { path: 'ads/video', Component: React.lazy(() => import('./LegacyVideoRedirect')), guard: { kind: 'card' } },
];

export default routes;
